import * as React from "react";
import { Input, InputGroup } from "@/components/ui";
import { stripCTAPrefix } from "@/services/bedrock";

interface ReadonlyCtaUrlProps {
  url: string;
  prefix?: string;
}

export const ReadonlyCtaUrl: React.FC<ReadonlyCtaUrlProps> = ({ url, prefix = "https://" }) => (
  <InputGroup
    className="w-full flex-grow"
    control={controlProps => (
      <Input
        {...controlProps}
        value={stripCTAPrefix(url, prefix) || url}
        readOnly
        tabIndex={-1}
        className="w-full flex-grow"
      />
    )}
    prepend={<p className="mb-0 font-normal border-r border-input pr-2 text-muted-foreground">{prefix}</p>}
  />
);
